const PNG_DATA_URL_PREFIX = 'data:image/png;base64';
export const prepareWatermarkImage = (imageBase64Data: string) =>
  `${PNG_DATA_URL_PREFIX},${imageBase64Data}`;
